
























import { Component, Prop, Vue } from 'vue-property-decorator';
import JourneyParameters from '@/models/interfaces/JourneyParameters';
import { setLanguage } from '@/assets/lang/I18n';
import { applyDocumentLanguage } from '@/services/Setupi18n';

@Component({})
export default class ErrorView extends Vue {
  @Prop() public title?: string;
  @Prop() public parameters?: JourneyParameters;
  @Prop() public datetime?: string;
  @Prop() public isWidget?: boolean;

  public mounted() {
    const lang: string = !!this.$route?.query?.lang !== false ? this.$route.query.lang.toString() : '';
    this.$root.$i18n.locale = setLanguage(lang);
    applyDocumentLanguage();
  }

  get errorTitle(): string {
    return this.title ? `errorMessages.${this.title}` : 'errorMessages.unexpectedError';
  }

  get errorDetails(): string {
    return this.errorTitle + 'Details';
  }
}
